// src/pages/media/PistonSection1.jsx
import React, { useRef, useLayoutEffect } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import heroVideo from '../../assets/images/herovideo1.mp4'

gsap.registerPlugin(ScrollTrigger)

export default function MultiTurbineSection1() {
  const sectionRef = useRef(null)
  const pinRef     = useRef(null)
  const videoRef   = useRef(null)
  const title1Ref  = useRef(null)
  const title2Ref  = useRef(null)

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger:    sectionRef.current,
          start:      'top top',
          end:        'bottom top',
          scrub:      true,
          pin:        pinRef.current,
          pinSpacing: false
        }
      })

      // 1) parallax up 150px
      tl.fromTo(
        videoRef.current,
        { y: 0 },
        { y: -150, ease: 'none' },
        0
      )

      // 2) swap titles exactly at 5%
      tl.set(title1Ref.current, {autoAlpha:0}, 0.02)
        .set(title2Ref.current, {autoAlpha:1}, 0.02)

    }, sectionRef)

    return () => ctx.revert()
  }, [])

  return (
    <section
      ref={sectionRef}
      className="relative h-[130vh] w-full overflow-visible"
    >
      {/* this 100vh container is the one we pin */}
      <div
        ref={pinRef}
        className="sticky top-0 h-screen w-full overflow-hidden"
      >
        <video
          ref={videoRef}
          src={heroVideo}
          autoPlay
          muted
          loop
          playsInline
          className="absolute top-0 left-0 w-full h-[calc(100vh+150px)] object-cover will-change-transform"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/20 to-transparent pointer-events-none" />

        <div className="absolute bottom-12 left-8 md:left-12 z-20 pointer-events-none">
          <h2
            ref={title1Ref}
            className="font-headline text-[15vw] md:text-[6vw] leading-none drop-shadow-md text-white"
          >
            CIRRUS&nbsp;SR280
          </h2>
          <h2
            ref={title2Ref}
            className="font-body text-[6vw] md:text-[3vw] font-normal leading-none drop-shadow-sm text-white absolute top-0 left-0"
            style={{ opacity: 0 }}
          >
            Captured&nbsp;in&nbsp;San&nbsp;Diego,&nbsp;CA
          </h2>
        </div>
      </div>
    </section>
  )
}
